webpackJsonp([29],{

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(577),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    data: {
      type: Object,
      required: true,
      default: undefined
    }
  },
  data: function data() {
    return {
      err: ''
    };
  },

  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
    },
    markAsRead: function markAsRead() {
      var _this = this;

      this.$http.post('announcement/markasread/' + this.data.id, {}).then(function (res) {
        if (res.body.status === 'Success') {
          _this.$emit('close');
        }
      }, function (err) {
        _this.err = err.body.statusText || err.body.message;
      });
    }
  }
});

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-4"
  }, [_c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Subject:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.data.subject))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Message:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.data.message))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Created On:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.data.createdOn)))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-space-between": "",
      "row": ""
    }
  }, [_c('v-btn', {
    staticClass: "elevation-0 mx-0",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Close\n    ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0 mx-0",
    attrs: {
      "disabled": _vm.data.isRead,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markAsRead()
      }
    }
  }, [_vm._v("\n      Mark as read\n    ")])], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.4af4e10038ff3664445e.js